(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('Customer', Customer);

    Customer.$inject = ['$resource', 'ENV'];

    function Customer($resource, ENV) {
        var resourceUrl = ENV.API_BASE_URL + 'api/customers/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
